var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37739_1011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78873 2.704C9.06221 2.40563 9.52545 2.38577 9.82339 2.65964L15.0302 7.44569C15.1804 7.58373 15.2663 7.77822 15.2673 7.98236C15.2683 8.18651 15.1843 8.38183 15.0354 8.52133L9.82863 13.4019C9.53337 13.6787 9.06996 13.6634 8.79359 13.3677C8.51721 13.072 8.53253 12.6079 8.82779 12.3312L12.6811 8.71927L8.87643 8.71928C8.472 8.71928 8.14415 8.39095 8.14415 7.98594C8.14415 7.58093 8.472 7.25261 8.87643 7.25261L12.6543 7.25261L8.83303 3.74014C8.53508 3.46627 8.51525 3.00238 8.78873 2.704ZM1.2207 7.98594C1.2207 7.58093 1.54856 7.25261 1.95299 7.25261H3.15128C3.55571 7.25261 3.88357 7.58093 3.88357 7.98594C3.88357 8.39095 3.55571 8.71928 3.15128 8.71928H1.95299C1.54856 8.71928 1.2207 8.39095 1.2207 7.98594ZM4.54928 7.98594C4.54928 7.58093 4.87714 7.25261 5.28157 7.25261H6.67957C7.084 7.25261 7.41186 7.58093 7.41186 7.98594C7.41186 8.39095 7.084 8.71928 6.67957 8.71928H5.28157C4.87714 8.71928 4.54928 8.39095 4.54928 7.98594Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37739_1011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9772,
    height: 16,
    fill: "white",
    transform: "translate(0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTo);
export default __webpack_public_path__ + "static/media/to.2eccf0a2c132d55719106ac07dfb4871.svg";
export { ForwardRef as ReactComponent };